<header>
  <h3>{{ title() | translate }}</h3>
</header>
<section>
  <p>{{ message() | translate }}</p>
</section>
<div class="divider"></div>
<footer [class.with-link]="linkButtons().length">
  @for (button of linkButtons(); track button.action) {
    <button (click)="close(button.action)" class="leave-link">
      {{ button.label | translate | upperFirstLetter }}
    </button>
  }
  <div class="actions">
    @for (button of actionButtons(); track button.action) {
      <button (click)="close(button.action)" [class]="'cta-' + button.style">
        {{ button.label | translate | upperFirstLetter }}
      </button>
    }
  </div>
</footer>
